const hamburger = document.querySelector('.hamburger');
const body = document.body;

hamburger.addEventListener('click', () => {
  body.classList.toggle('menu-active');
});



// WEBPACK FOOTER //
// ./assets/js/src/menu.js